import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

import { cn } from 'lib/helpers/utility';

import useModalEnterKey from '../lib/useModalEnterKey';

import Body from './components/Body';
import Footer from './components/Footer';
import Header from './components/Header';
import { getTypePresets } from './getTypePresets';

/**
 * @param {import('./lib/propTypes').ConfirmProps}
 */

const Confirm = ({
  type = 'confirm',
  icon,
  iconSize = 24,
  iconColor,
  variant,
  title,
  message,
  children,
  isOpen = false,
  handleOpen = false,
  handleClose,
  customClassName,
  overlayClassName = null,
  childrenClassName,
  footer,
  footerActions,
  isFooter = true,
  showDontShowThisMessageAgain = false,
  dontShowAgain: controlledDontShowAgain,
  onDontShowAgainChange,
  ...rest
}) => {
  const [internalDontShowAgain, setInternalDontShowAgain] = useState(false);
  const dontShowAgain = controlledDontShowAgain ?? internalDontShowAgain;

  useEffect(() => {
    if (!isOpen && !handleOpen) {
      setInternalDontShowAgain(false);
    }
  }, [handleOpen, isOpen]);

  useModalEnterKey({
    isOpen: isOpen || handleOpen,
    isFooter,
    button: footerActions?.primary
  });

  const handleDontShowAgainChange = () => {
    const nextValue = !dontShowAgain;
    if (onDontShowAgainChange) {
      onDontShowAgainChange(nextValue);
    }
    if (controlledDontShowAgain === undefined) {
      setInternalDontShowAgain(nextValue);
    }
  };

  const preset = getTypePresets({ type, icon, variant, title, message });
  const finalIcon = preset.icon;
  const finalVariant = preset.variant;
  const finalTitle = preset.title;
  const finalMessage = preset.message;

  return (
    <ReactModal
      isOpen={isOpen || handleOpen}
      onRequestClose={handleClose}
      contentLabel={title}
      ariaHideApp={false}
      className={cn(
        'relative z-[100] w-[460px] rounded-md border border-solid border-neutral-200 bg-white shadow-[0px_0px_16px_0px_rgba(55,65,69,0.08)] outline-none',
        customClassName
      )}
      overlayClassName={cn('ModalOverlay', overlayClassName)}
      {...rest}>
      <Header
        icon={finalIcon}
        iconSize={iconSize}
        iconColor={iconColor}
        variant={finalVariant}
        title={finalTitle}
        message={finalMessage}
        handleClose={handleClose}
        dontShowAgain={dontShowAgain}
        setDontShowAgain={handleDontShowAgainChange}
        showDontShowThisMessageAgain={showDontShowThisMessageAgain}
      />
      <Body body={children} childrenClassName={childrenClassName} />
      <Footer
        footer={footer}
        footerActions={footerActions}
        isFooter={isFooter}
        handleClose={handleClose}
        variant={finalVariant}
      />
    </ReactModal>
  );
};

export default Confirm;
